import { render, staticRenderFns } from "./SearchNavItemDate.vue?vue&type=template&id=796708d8&scoped=true&"
import script from "./SearchNavItemDate.vue?vue&type=script&lang=js&"
export * from "./SearchNavItemDate.vue?vue&type=script&lang=js&"
import style0 from "./SearchNavItemDate.vue?vue&type=style&index=0&id=796708d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796708d8",
  null
  
)

export default component.exports